/**
 * Logic Necessary for the CPE Detail
 * Author: Imarc 2019
 */

// Dependencies
import '../modules/tabs';
import '../modules/biomodal';
import stickyBottom from '../modules/stickybottom';

stickyBottom({
    stickySelector: '.js-stickyBottom',
    nextReferenceElement: '.site-footer',
});

/**
 * Leader Jump Link Assist
 */
const leaderLinks = [...document.querySelectorAll('.js-leaderLink')];

if (leaderLinks.length) {
    leaderLinks.forEach(leaderLink => {
        leaderLink.addEventListener('click', event => {
            event.preventDefault();

            const { id } = leaderLink.dataset;
            const leaderBio = document.querySelector(`[data-person="${id}"]`);
            const leaderPosition = getPosition(leaderBio)

            window.scrollTo({
                top: leaderPosition.y,
                left: 0,
                behavior: 'smooth'
            })
        })
    })
}
 
function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;

    while(element) {
        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}